import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5289/api";
export const apiClient = axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
apiClient.interceptors.response.use((response) => response, async (error) => {
    if (error.response?.status === 401) {
        // Don't redirect if already on login/otp pages
        const currentPath = window.location.pathname;
        const isAuthPage = currentPath === "/login" || currentPath === "/otp";
        if (!isAuthPage) {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user");
            window.location.href = "/login";
        }
    }
    return Promise.reject(error);
});
